import { Ban } from 'lucide-react';

interface BanAttentionBannerProps {
  count: number;
  onClick?: () => void;
}

/**
 * Sticky top banner shown when one or more accounts are `banned` (the gateway
 * reported a persistent 403 / "Connection Failure" ban signature).
 *
 * The parallel of `QrAttentionBanner`, but RED and louder: a ban is the worst
 * account state and — unlike `qr_required` — a re-scan will NOT recover it, so
 * the operator must be unmistakably alerted. This was the paid-in-blood gap:
 * before ban detection a banned number looked like a normal `connecting`
 * reconnect, so an actual ban went unnoticed until someone dug through gateway
 * logs by hand. Clicking scrolls/highlights the first banned row (handled by
 * the parent via `onClick`). Returns `null` when `count === 0`.
 *
 * DETECTION only: the gateway keeps auto-retrying the banned number (stopping
 * that churn is a separate future gateway patch); this banner just makes the
 * state visible so an operator can retire / appeal the number.
 */
export function BanAttentionBanner({
  count,
  onClick,
}: BanAttentionBannerProps): React.JSX.Element | null {
  if (count <= 0) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className="neu-pressable sticky top-0 z-10 mx-4 mt-1 flex items-center gap-2 rounded-[13px] bg-red-100/80 px-4 py-2.5 text-left text-xs font-bold text-red-900 shadow-neu-raised hover:bg-red-100 hover:shadow-neu-raised-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 dark:bg-red-950/40 dark:text-red-200 dark:hover:bg-red-950/60"
    >
      <Ban className="size-4 shrink-0" aria-hidden="true" />
      <span>
        {count} 个账号疑似封号 · 重扫无效
      </span>
    </button>
  );
}
